package com.macrofocus.eflux

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.common.properties.PropertyEvent
import com.macrofocus.common.properties.PropertyListener
import com.macrofocus.common.properties.SimpleProperty
import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.common.selection.MutableSingleSelection
import com.macrofocus.eflux.diagram.DiagramType
import com.macrofocus.eflux.network.*
import com.macrofocus.eflux.network.logical.*
import korlibs.time.DateTime
import org.molap.dataframe.DataFrame
import react.useRef
import svgpanzoom.SvgPanZoomContext
import web.geometry.DOMMatrixReadOnly
import web.html.HTMLDivElement
import web.svg.SVGElement
import web.svg.SVGSVGElement
import kotlin.time.ExperimentalTime
import kotlin.time.measureTime

class ViewLoader(private val itcmDataFrame: MutableProperty<DataFrame<Int, String, Any?>?>,
                 private val logicalNetwork: MutableProperty<LogicalNetwork?> = SimpleProperty(null),
                 diagramTypeProperty: SimpleProperty<DiagramType>,
                 parameters: Map<String, String?>,
                 private val masterDateTime: MutableProperty<DateTime>,
                 private val pointProbing: MutableSingleSelection<LogicalBusId>,
                 private val pathProbing: MutableSingleSelection<LogicalBranchId>,
                 private val pointSelection: MutableSelection<LogicalBusId>,
                 private val pathSelection: MutableSelection<LogicalBranchId>,
                 val url: String,
                 private val type: DiagramType
) {
    val efluxNetwork: MutableProperty<EFluxNetwork?> = SimpleProperty(null)
    val graphicalNetwork: MutableProperty<GraphicalNetwork?> = SimpleProperty(null)

    val svg: MutableProperty<SVGSVGElement?> = SimpleProperty(null)
    val svgPanZoomContext: MutableProperty<SvgPanZoomContext?> = SimpleProperty(null)

    val svgMatrix: MutableProperty<DOMMatrixReadOnly?> = SimpleProperty(null)

    init {
        svg.addPropertyListener(object : PropertyListener<SVGSVGElement?> {
            override fun propertyChanged(event: PropertyEvent<SVGSVGElement?>) {
                createGraphicalNetwork()
            }
        })

        itcmDataFrame.addPropertyListener(object : PropertyListener<DataFrame<Int, String, Any?>?> {
            override fun propertyChanged(event: PropertyEvent<DataFrame<Int, String, Any?>?>) {
                createGraphicalNetwork()
            }
        })
        createGraphicalNetwork()

//        diagramTypeProperty.addPropertyListener(object : PropertyListener<DiagramType> {
//            override fun propertyChanged(event: PropertyEvent<DiagramType>) {
//                if(type == diagramTypeProperty.value) {
//                    createEFluxNetwork(parameters["select"])
//                }
//            }
//        })

        logicalNetwork.addPropertyListener(object : PropertyListener<LogicalNetwork?> {
            override fun propertyChanged(event: PropertyEvent<LogicalNetwork?>) {
                if(type == diagramTypeProperty.value) {
                    createEFluxNetwork(parameters["select"])
                }
            }
        })
        this.graphicalNetwork.addPropertyListener(object : PropertyListener<GraphicalNetwork?> {
            override fun propertyChanged(event: PropertyEvent<GraphicalNetwork?>) {
                if(type == diagramTypeProperty.value) {
                    createEFluxNetwork(parameters["select"])
                }
            }
        })
        if(type == diagramTypeProperty.value) {
            createEFluxNetwork(parameters["select"])
        }
    }

    @OptIn(ExperimentalTime::class)
    private fun createGraphicalNetwork() {
        val svg = svg.value
        val itcmDataFrame = itcmDataFrame.value

        if (svg != null && itcmDataFrame != null) {
            println("Creating graphical network")
            val graphical: GraphicalNetwork
            with(measureTime {
                graphical = GraphicalNetwork(svg, itcmDataFrame)
            }) {
                println("Graphical network created in $this")
            }
            graphicalNetwork.value = graphical
        } else {
            graphicalNetwork.value = null
        }
    }

    @OptIn(ExperimentalTime::class)
    private fun createEFluxNetwork(selectAsString: String?) {
        val logicalNetwork = logicalNetwork.value
        val graphicalNetwork = this.graphicalNetwork.value
        if (logicalNetwork != null && graphicalNetwork != null) {
            println("Creating EFlux network...")
            val logicalEFluxNetwork: LogicalEFluxNetwork
            with(measureTime {
                logicalEFluxNetwork = LogicalEFluxNetwork(logicalNetwork, graphicalNetwork, masterDateTime.value, type)
            }) {
                println("EFlux network created in $this")
            }

            with(measureTime {
                efluxNetwork.value = logicalEFluxNetwork

                // Update probing
                val busId = pointProbing.selected
                if(busId != null) {
                    logicalEFluxNetwork.graphicalNodes.get(busId)?.let { pointProbing.selected = it.id }
                }

                val branchId = pathProbing.selected
                if(branchId != null) {
                    logicalEFluxNetwork.graphicalLinks.get(branchId)?.let { pathProbing.selected = it.id }
                }

                // Update selection
                // Find equivalent logical nodes
                val busIds : MutableList<LogicalBusId> = ArrayList()
                for (node in pointSelection) {
                    node.let { busIds.add(it) }
                }
                val nodes : MutableList<EFluxNode> = ArrayList()
                for (busId in busIds) {
                    logicalEFluxNetwork.graphicalNodes.get(busId)?.let { nodes.add(it) }
                }
                if(nodes.size > 0) {
                    println("Selecting ${nodes.size} nodes")
                }
//                pointSelection.setSelectedIterable(nodes)

                // Find equivalent logical branches
                val branchIds : MutableList<LogicalBranchId> = ArrayList()
                for (link in pathSelection) {
                    link.let { branchIds.add(it) }
                }
                val links : MutableList<EFluxLink> = ArrayList()
                for (branchId in branchIds) {
                    logicalEFluxNetwork.graphicalLinks.get(branchId)?.let { links.add(it) }
                }

                if(links.size > 0) {
                    println("Selecting ${links.size} links (${links[0]})")
                }
//                pathSelection.setSelectedIterable(links)


            }) {
                println("EFlux network set in $this")
            }

            if (selectAsString != null) {
                for (id in selectAsString.split(",")) {
                    if (id.contains("-")) {
                        val branchId = logicalBranchIdOf(id)
                        logicalEFluxNetwork.graphicalLinks.get(branchId)
                            ?.let { pathSelection.setSelectedState(branchId, true) }
                    } else {
                        val busId = logicalBusIdOf(id)
                        logicalEFluxNetwork.graphicalNodes.get(busId)
                            ?.let { pointSelection.setSelectedState(busId, true) }
                    }
                }
            }
        } else {
            efluxNetwork.value = null
        }

//        if(efluxNetwork.value != null) {
//        } else {
//            pointSelection.clearSelection()
//            pathSelection.clearSelection()
//        }
    }
}